import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GlobalSettingsComponent } from './pages/global-settings/global-settings.component';

const routes: Routes = [
  {
    path: '',
    component: GlobalSettingsComponent,
    children: [],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), CommonModule],
  exports: [RouterModule],
})
export class GlobalSettingsRoutingModule {}
